<template>
     <div class="item-search">
        <PageTitle icon="fa fa-folder-o" :main="groupitem.name" sub="Itens do Grupo" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="item-id" type="hidden" v-model="item.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group label="Nome:" label-for="item-name">
                        <b-form-input id="item-name" type="text" ref="searchFocus"
                            v-model="item.name" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Nome do Item..." />
                    </b-form-group>
                </b-col>    
                <b-col md="2" sm="12">    
                     <b-form-group label="Código Interno:" label-for="item-internal">
                        <b-form-input id="item-internal_code" type="text"
                            v-model="item.internal_code" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Código..." />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group 
                        label="Unidade:" label-for="item-unit_measure_id">
                        <b-form-select id="item-unit_measure_id"
                        size="sm"
                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        :options="unitmeasures" v-model="item.unit_measure_id" />
                    </b-form-group>
                </b-col>
                  <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="item.stock" true-value="1" false-value="0" 
                                type="checkbox" 
                                id="item-stock"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="item-stock">
                                Estoque?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="item.service" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="item-service"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="item-service">
                                Serviço?
                            </label>
                        </div>
                    </div>
                    </b-col>  
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="item.blocked" true-value="1" false-value="0" 
                                type="checkbox" 
                                id="item-blocked"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="item-blocked">
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>  
              
             </b-row>
               <b-card no-body>
                   <b-tabs card vertical >
                       <b-tab title="Complemento" active>
                            <b-row>
                                <b-col md="6" sm="12">
                                <b-form-group label="Decrição do Item:" label-for="item-description">
                                    <b-form-textarea id="item-description"
                                        :rows="3"
                                        :max-rows="6"
                                        size="sm"
                                        v-model="item.description"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="" />
                                </b-form-group>
                                </b-col>
                            </b-row>
                       </b-tab>
                        <b-tab title="Informações tributárias">
                            <b-row>
                                <b-col md="3" sm="12">    
                                    <b-form-group label="NCM:" label-for="item-ncm">
                                        <b-form-input id="item-ncm" type="text"
                                            v-model="item.ncm" 
                                            size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Código NCM..." />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">    
                                    <b-form-group label="CEST:" label-for="item-cest">
                                        <b-form-input id="item-cest" type="text"
                                            v-model="item.cest" 
                                            size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Código CEST..." />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                 <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Tipo de Item:" 
                                        label-for="item-efd_type_item_id">
                                        <b-form-select id="item-efd_type_item_id"
                                        size="sm"
                                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        :options="efdtypeitems" 
                                        v-model="item.efd_type_item_id" />
                                    </b-form-group>
                                </b-col>
                                 <b-col md="5" sm="12">
                                    <b-form-group 
                                        label="Gênero do Item:" 
                                        label-for="item-efd_genre_id">
                                        <b-form-select id="item-efd_genre_id"
                                        size="sm"
                                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        :options="efdgenres" 
                                        v-model="item.efd_genre_id" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="4" sm="12">
                                    <b-form-group 
                                        label="Origem do Item:" 
                                        label-for="item-efd_source_id">
                                        <b-form-select id="item-efd_source_id"
                                        size="sm"
                                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        :options="efdsources" 
                                        v-model="item.efd_source_id" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-tab>
                        <b-tab title="Informações sobre serviço" >
                            <b-row>
                                 <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="REINF:" 
                                        label-for="item-reinf_service_id">
                                        <b-form-select id="item-reinf_service_id"
                                        size="sm"
                                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        :options="reinfservices" 
                                        v-model="item.reinf_service_id" />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                       </b-tab>
                   </b-tabs>
               </b-card>   
            <b-row>
                <b-col md="8" sm="12">
                    <b-form-group 
                        class="mt-2"
                        label="Nome Completo:" 
                        label-for="item-complements_name">
                        <b-form-input id="item-complements_name" type="text" 
                            v-model="item.complements_name"
                            size="sm"
                            :readonly="true"
                            placeholder="Nome do Item Completo..." />
                    </b-form-group>
                </b-col>   
            </b-row>
            <br>
         </b-form>
              <b-row>
                <b-col xs="12">
                    <b-button 
                         size="sm" 
                        variant="dark" 
                        title="Adicionar"
                        class="mr-2 mt-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button  
                        size="sm" 
                        variant="dark" 
                        title="Salvar"
                        class="mr-2 mt-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                    </b-button>
                    <b-button  
                        size="sm" 
                        variant="dark" 
                         title="Remover"
                        class=" mt-2 mr-2 fa fa-trash"  
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button  
                        size="sm" 
                        variant="dark" 
                        title="Voltar"
                        class=" mt-2 mr-2 fa fa-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button  
                        size="sm" 
                        btn-sm 
                        title="Retorna para o Grupo de Item"
                        variant="dark" 
                        class="mt-2" 
                        @click="goback"><i class="fa fa-mail-reply-all"></i></b-button> 
                </b-col>
            </b-row>
            <br>
         <b-row>
            <div class="col-sm-4">
                <div class="form-group">
                    <input type="text" icon="search" v-model="search" placeholder="Informe o nome do Item" class="form-control">
                </div>
            </div>
            </b-row>
           <transition  name="slide" type="animation" appear>  
            <b-table 
                    :busy="isBusy"  
                    :per-page="perPage" 
                    :current-page="currentPage" 
                    class="table-responsive" 
                    hover 
                    head-variant="light" 
                    :items="filteredList" 
                    :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                    <b-button  
                        size="sm" 
                        variant="light"
                         @click="loaditem(data.item, 'read')" 
                         class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        size="sm" 
                        variant="light" 
                        @click="loaditem(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        size="sm" 
                        variant="light" 
                        @click="loaditem(data.item, 'remove')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>   
                 <template v-slot:cell(accesses)="data">
                    <b-button  
                        title = "Acesso aos Cadastro do Item" 
                        size="sm" 
                        variant="light" 
                        @click="actionItem(data.item)" 
                        class="mr-2 mt-2 fa fa-external-link">
                    </b-button>
                    <b-button  
                        title = "Registro de Preço de Venda" 
                        size="sm" 
                        variant="light" 
                        @click="loadItemPrice(data.item)" 
                        v-b-modal.modalPrice 
                        class="mr-2 mt-2 fa fa-plus-circle">
                    </b-button>
                    <b-button  
                        title = "Consulta de Preço de Venda" 
                        size="sm" 
                        variant="light" 
                        @click="loadItemPrices(data.item)" 
                        v-b-modal.modalTablePrice 
                        class="mr-2 mt-2 fa fa-drivers-license-o">
                    </b-button>
                    <!--b-button  title = "Imprimir Código de Barra" size="sm" variant="secondary" @click="printItemCodeBar(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-print"></i>
                    </b-button-->
                 </template> 
            </b-table>
           </transition>
         <transition  name="slide" type="animation" appear>
            <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
         <b-modal id="modalPrice"
            ref="modal"
            title-tag = "h6"
            title="Registro de Tabela de Preço"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveItemPrice"
            >
           <b-form>
               <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group 
                            label="Empresa:" label-for="itemsprice-company_id">
                            <b-form-select id="itemsprice-company_id"
                            size="sm"
                            :options="companys" v-model="itemsprice.company_id" />
                        </b-form-group>
                    </b-col>
               </b-row>
               <b-row>
                   <b-col md="12" sm="12">
                         <b-form-group 
                            label="Tabela de Preço:" label-for="itemsprice-type_price_id">
                            <b-form-select id="itemsprice-type_price_id"
                            size="sm"
                            :options="typeprices" v-model="itemsprice.type_price_id" />
                        </b-form-group>
                    </b-col>
               </b-row>
                <b-row>
                    <b-col md="5" sm="12">
                        <b-form-group label="Data de Início:" label-for="itemsprice-start_date">
                        <b-form-input id="itemsprice-start_date" type="date"
                            v-model="itemsprice.start_date" 
                            size="sm"
                        />
                        </b-form-group>
                    </b-col> 
                    <b-col md="5" sm="12">
                        <b-form-group label="Data de Termino:" label-for="itemsprice-end_date">
                        <b-form-input id="itemsprice-end_date" type="date"
                            v-model="itemsprice.end_date" 
                            size="sm"
                        />
                        </b-form-group>
                    </b-col> 
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <b-form-group label="Valor Unitário:" label-for="itemsprice-price_sale">
                        <b-form-input id="itemsprice-price_sale" 
                            v-model="itemsprice.price_sale" 
                            type="number"
                            step="0.02"
                             size="sm"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col> 
                </b-row>
           </b-form>

        </b-modal> 
        <b-modal id="modalTablePrice"
            ref="modal"
            title-tag = "h6"
            hide-footer
            size="lg"
            title="Consulta de Preço"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            >
            <b-form>
                <b-table class="table-responsive" hover key="slide" striped :items="itemsprices" :fields="fieldsPrice">
                </b-table> 
            </b-form>
          </b-modal>
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
var moment = require('moment')

export default {
    name: 'ItemSearch',
     directives: {moment},
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                groupitem: {},
                item: {},
                items: [],
                itemsprice:{},
                itemsprices:[],
                unitmeasures: [],
                companys:[],
                typeprices:[],
                efdtypeitems:[],
                efdgenres:[],
                efdsources: [],
                reinfservices:[],
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                perPage: 5,
                currentPage: 1,
                isBusy: false,
                fields: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'complements_name', label: 'Nome', sortable: true, variant: 'secondary' },
                { key: 'description', label: 'Descrição', sortable: true },
                { key: 'internal_code', label: 'Código Interno', sortable: false },
                { key: 'stock', label: 'Estoque', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },    
                { key: 'service', label: 'Serviço', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },            
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },               
                { key: 'actions', label: 'Ações', variant: 'light' },
                { key: 'accesses', label: 'Acessos', variant: 'secondary' }
                ],
                fieldsPrice: [
                { key: 'name_company', label: 'Empresa', sortable: true },
                { key: 'name_type_price', label: 'Tabela de Preço.', sortable: false },
                { key: 'start_date', label: 'Data de Início.', sortable: false,
                    formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '')
                 },
                { key: 'end_date', label: 'Data de Termino.', sortable: false,
                    formatter: value => (value ? moment.utc(value).format("DD-MM-YYYY") : '')
                 },
                { key: 'price_sale', label: 'Vr. Venda Unitário', sortable: false },      
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },               
                { key: 'actions', label: 'Ações' }
                ],
            }
        },
        computed: {
            compan(){
                return this.$store.state.compan
            },
            filteredList() {
                return this.items.filter(item => {
                    return item.complements_name.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            rows() {
                return this.items.length
            },
            
        },
        methods:{
             getGroupItem(){
                const url = `${baseApiUrl}/groupitems/${this.groupitem.id}`
                axios(url).then(res=> this.groupitem = res.data)
            },
             toggleBusy() {
                this.isBusy = !this.isBusy
            },
            formatDate (date) {
                return moment.utc(date).format('YYYY-MM-DD')
            },
            goback(){
                 this.$router.go(-1, {query: 'q=s', hash: 'hashFrag'})
            },
            getItems(){
                const url = `${baseApiUrl}/groupitems/${this.groupitem.id}/items`
                axios(url).then(res =>{
                     this.items = res.data
                     this.isBusy = false
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.item = {}
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.item = {}
                this.getItems()
            },
            save() {
                if(this.groupitem.id){

                    this.item.group_item_id = this.groupitem.id
                }
                if(this.groupitem.complements_item === 1)
                {
                 this.item.complements_name = (this.groupitem.name + ' ' + this.item.name)
                }
                else
                {
                  this.item.complements_name = this.item.name   
                }
                const method = this.item.id ? 'put' : 'post'
                const id = this.item.id ? `/${this.item.id}` : ''
                axios[method](`${baseApiUrl}/items${id}`, this.item)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.item.id
                    axios.delete(`${baseApiUrl}/items/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            loadUnitMeasure() {
                    const url = `${baseApiUrl}/unitmeasures`
                    axios.get(url).then(res => {
                        this.unitmeasures = res.data.map(unitmeasure => {
                            return { value: unitmeasure.id, text: unitmeasure.initials }
                        })
                    })
            },
            loaditem(item, mode = 'save') {
                this.mode = mode
               
                this.item = { ...item }
                if(this.groupitem.complements_item === 1)
                {
                 this.item.complements_name = (this.groupitem.name + ' ' + this.item.name)
                }
                else
                {
                  this.item.complements_name = this.item.name   
                }
                this.$refs.searchFocus.focus();
            },
            actionItem(item) {                   
                this.$router.push({
                    name: 'recordItem',    
                    params: {id: item.id}
                })
            },
            printItemCodeBar(item){
                 if(!this.compan)
                {
                    this.$toasted.global.defaultError({msg:'Logar na Empresa'})
                }else
                {    
                const url = `${baseApiUrl}/itemcodebarprinter/${item.id}/?company_id=${this.compan.id}`
                axios.get(url)
                window.open(url)
                }
            },
            loadItemPrice(item){

                const date = new Date() 
                this.itemsprice= {}

                this.itemsprice.start_date = moment.utc(date).format('YYYY-MM-DD')
                this.itemsprice.item_id = item.id

                if(this.compan)
                {
                    this.itemsprice.company_id = this.compan.id
                }
                    
                if(this.compan.typePriceStandard){
                    this.itemsprice.type_price_id = this.compan.typePriceStandard
                }
                
            },
            saveItemPrice() {
                const method = this.itemsprice.id ? 'put' : 'post'
                const id = this.itemsprice.id ? `/${this.itemsprice.id}` : ''

                axios[method](`${baseApiUrl}/itemsprice${id}`, this.itemsprice)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)
            },
            loadCompanys() {
                    const url = `${baseApiUrl}/companys`
                    axios.get(url).then(res => {
                        this.companys = res.data.map(company => {
                            return { value: company.id, text: company.name_company }
                        })
                    })
            },
            loadTypePrices() {
                const url = `${baseApiUrl}/typeprice`
                axios.get(url).then(res => {
                    this.typeprices = res.data.map(typeprice => {
                        return { value: typeprice.id, text: typeprice.name_type_price }
                    })
                })
            },
            loadItemPrices(item){
                const url = `${baseApiUrl}/itemsprice/${item.id}/items`
                axios(url).then(res =>{
                     this.itemsprices = res.data
                })
            },
            loadEfdTypeItems() {
                    const url = `${baseApiUrl}/efdtypeitems`
                    axios.get(url).then(res => {
                        this.efdtypeitems = res.data.map(efdtypeitem => {
                            return { value: efdtypeitem.id, text: efdtypeitem.name_type_item }
                        })
                    })
            },
            loadEfdGenres() {
                    const url = `${baseApiUrl}/efdgenres`
                    axios.get(url).then(res => {
                        this.efdgenres = res.data.map(efdgenre => {
                            return { value: efdgenre.id, text: efdgenre.name_genre }
                        })
                    })
            },
            loadEfdSources() {
                    const url = `${baseApiUrl}/efdsources`
                    axios.get(url).then(res => {
                        this.efdsources = res.data.map(efdsource => {
                            return { value: efdsource.id, text: efdsource.name_source }
                        })
                    })
            },
             loadReinfServices() {
                    const url = `${baseApiUrl}/reinfservices`
                    axios.get(url).then(res => {
                        this.reinfservices = res.data.map(reinfservice => {
                            return { value: reinfservice.id, text: reinfservice.name_reinf }
                        })
                    })
            },
        },
        watch:{
            $route(to){
                this.groupitem.id = to.params.id
                this.items = []
                this.getGroupItem()
                this.getItems()
            }

        },
        mounted(){
            this.groupitem.id = this.$route.params.id
            this.getGroupItem()
            this.getItems()
            this.toggleBusy()
            this.loadUnitMeasure()
            this.loadCompanys()
            this.loadTypePrices()
            this.loadEfdTypeItems()
            this.loadEfdGenres()
            this.loadEfdSources()
            this.loadReinfServices()
        }
}
</script>

<style>

    .item-search{
        font-size: 0.7rem;
   
    }

    .item-search select{
        font-size: 0.7rem;
   
    }

    .item-search button{
        font-size: 0.7rem;
    }

    .item-search input{
        font-size: 0.7rem;
    }

    #modalPrice {
        font-size: 0.7rem;
    }

    #modalPrice select {
        font-size: 0.7rem;
    }

    #modalPrice button {
        font-size: 0.7rem;
    }

    #modalPrice input {
        font-size: 0.7rem;
    }

    #modalTablePrice {
        font-size: 0.7rem;
    }

    #modalTablePrice select {
        font-size: 0.7rem;
    }

    #modalTablePrice button {
        font-size: 0.7rem;
    }

    #modalTablePrice input {
        font-size: 0.7rem;
    }

</style>
